<template>
  <div>
    <div class="card">
      <div class="page-title">{{$t('message.login_title')}}</div>
      <ErrorMsg :backError="backendMsg" @clearError="CloseError"></ErrorMsg>
      <Form
        ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        :lang="'lang'"
      >
        <FormItem prop="email">
          <Gtinput width="290px"
            v-model="formValidate.email"
            type="text"
            :placeholder="$t('message.email_placeholder')"
            PreIcon="email"
            @on-blur="checkemail()"
          >
          </Gtinput>
        </FormItem>


        <div class="check_email"  v-if="riskDetection">
          <!-- <div v-if="language === 'en' && riskDetection" class="geetest-btn geetest-check-risk" :class="{'disabled': true}">
            {{$t('message.risk_detection')}}
          </div> -->
            <Gtinput width="290px"
              v-model="secondCode"
              type="text"
              :placeholder="$t('message.risk_detection_content')"
              PreIcon="lock"
            >
            </Gtinput>
        </div>
        



        <FormItem prop="password">
          <Gtinput width="290px"
            v-model="formValidate.password"
            :type="type"
            :placeholder="$t('message.password_placeholder')"
            PreIcon="lock"
          >
          </Gtinput>
          <div @click="handle" class="eye-icon">
            <GtIcon icon='eye'
              class="icon-password-on"
              :class="{ 'hide-opcity': type == 'password' }"/>
          </div>
        </FormItem>
        <div class="captcha-wrapper">
          <Captcha
            :reSent="reSet"
            :email="formValidate.email"
            @reSentEvent="reSentEvents"
            @capError="captchaError"
            :CaptchaId="'captchaIdLogin'"
            :lang="$i18n.locale"
          ></Captcha>
          </div>
        <div class="keep-box">
          <div class="keep-status">
            <div>
              <Checkbox v-model="rember" :label="$t('message.keeplogin')"></Checkbox> 
            </div>
            <router-link :to="{ name: 'reset' }" target="_blank"
              >{{ $t("message.forget") }}?</router-link
            >
          </div>
        </div>
        <div class="geetest-btn" @click="loginSubmit('formValidate')" :class="{'disabled': loading}">
          {{ $t("message.sign") }}
          <i class="geetest-icons">arrow_forward</i>
        </div>
        <div class="page-note">
          <a :href="$t('message.registerInfo_link')" target="_blank">
            {{$t('message.go_register_text')}}
          </a></div>
      </Form>
    </div>
  </div>
</template>
<script>
import rightIcon from "assets/img/right_icon.svg";
import Captcha from "components/captcha";
import ErrorMsg from "components/errorMsg";
import { checkEmail } from 'api/login'
import { auth } from "api/auth";
import store from "store";
import { mapState } from "vuex";
import CryptoJS from 'crypto-js';
export default {
  inject: ["reload"],
  data() {
    return {
      loading: false,
      reSet: false,
      formValidate: {
        email: "",
        password: "",
      },
      ruleValidate: {
        email: [
          {
            required: true,
            message: this.$t("message.email_requred"),
            trigger: "change",
          },
          {
            required: true,
            message: this.$t("message.email_requred"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("message.password_requred"),
            trigger: "blur",
          },
          {
            required: true,
            message: this.$t("message.password_requred"),
            trigger: "change",
          },
        ],
      },
      type: "password",
      geetestCaptcha: {},
      backendMsg: "",
      rember: false,
      rightIcon: rightIcon,
      localLang: {},
      formactive: false,
      riskDetection:false, //加入此参数来判断是否弹出邮箱验证码
      secondCode: ''
    };
  },
  mounted() {},
  computed: {
    ...mapState({
      language: (state) => state.Gtlang,
    }),
  },
  methods: {
    encrypt(data ,key , iv){
        if( typeof data === "object" ){
            // 如果传入的data是json对象，先转义为json字符串
            try {
                data = JSON.stringify(data)
            } catch (error) {
                console.log("error:",error)
            }
        }
         // 统一将传入的字符串转成UTF8编码
        const dataHex = CryptoJS.enc.Utf8.parse( data ) // 需要加密的数据
        const keyHex = CryptoJS.enc.Utf8.parse( key ) // 秘钥
        const ivHex = CryptoJS.enc.Utf8.parse( iv ) // 偏移量
        const encrypted = CryptoJS.AES.encrypt( dataHex , keyHex , {
          iv: ivHex,
          mode: CryptoJS.mode.CBC, // 加密模式
          padding: CryptoJS.pad.ZeroPadding
        })
        let encryptedBase64Data = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
        return encryptedBase64Data //  返回加密后的值
	},

    loginSubmit(name) {
      let data = this.formValidate;
      const key = 'geetest_au250106'; // 设置密钥为16字节长度的十六进制字符串
      const iv = 'qqqqqqqqqqqqqqqq';
      data.password = this.encrypt(data.password,key,iv)
      const that = this
      that.loading = true;
      if (that.riskDetection) {
        Object.assign(data, this.geetestCaptcha,{'e_code': that.secondCode});
        that.$refs[name].validate((valid) => {
        if (valid) {
          this.loading && this.$store.dispatch("LoginEn", data).then((res) => {
            this.loading = false;
            if (res.data.status == 1) {
              this.$router.push("/product");
              sensors.track("AuthLoginEn", {
                user_source: "AuthLoginEn"
              });
            } else {
              this.reSet = true;
              // 在英文情况下，验证码不正确时，服务返回错误信息是中文，暂时前端简单处理
              if (res.data.err_code === 1201 && this.language === "en") {
                this.backendMsg = "The parameter is incorrect";
              } else {
                this.backendMsg = res.data.err_msg;
              }
            }
          }, () => {
            this.loading = false;
          });
        } else {
          this.loading = false
        }
      });
      } else {
        Object.assign(data, that.geetestCaptcha);
        that.$refs[name].validate((valid) => {
        if (valid) {
          this.loading && this.$store.dispatch("Login", data).then((res) => {
            this.loading = false;
            if (res.data.status == 1) {
              this.$router.push("/product");
              sensors.track("AuthLoginZh", {
                user_source: "AuthLoginZh"
              });
            } else {
              this.reSet = true;
              // 在英文情况下，验证码不正确时，服务返回错误信息是中文，暂时前端简单处理
              if (res.data.err_code === 1201 && this.language === "en") {
                this.backendMsg = "The parameter is incorrect";
              } else {
                this.backendMsg = res.data.err_msg;
              }
            }
          }, () => {
            this.loading = false;
          });
        } else {
          this.loading = false
        }
      });
      }
    },
    handle() {
      if (this.type == "text") {
        this.type = "password";
      } else {
        this.type = "text";
      }
    },
    reSentEvents(data, status) {
      this.reSet = status;
      this.geetestCaptcha = data;
    },
    captchaError(data) {
      if (!data) {
        this.$refs["formValidate"].validate();
        return;
      }
    },
    CloseError(data) {
      this.backendMsg = data;
    },
    keeplogin(e) {
      this.rember = e.target.checked;
    },
    changeLange() {
      this.$refs["formValidate"].resetFields();
    },
    checkemail() {
      // console.log(this.formValidate.email);
      let data ={'email':this.formValidate.email};
      const that = this
      
      if (this.formValidate.email != "" ) {
        checkEmail(data).then((res) => {
          if (res.data.status == 1) {
            that.riskDetection = false
          } else if(res.data.status == 2) {
            that.riskDetection = true
          } else if(res.data.status == -1) {
            that.riskDetection = true
            if (that.language == "en") {
              that.backendMsg = "Sent Mail";
            } else {
              that.backendMsg = "发送邮件"
            }
          } else if (res.data.status == 0) {
              if (that.language == "en") {
                that.backendMsg = "Missing data for required field.";
              } else {
                that.backendMsg = "必填字段缺少数据"
              }
          }else {
            that.backendMsg = res.data.err_msg.email;
          }
        }, (err) => {
          console.log(err);
        });
      
      }
      
    }
  },
  components: { Captcha, ErrorMsg },
  created() {
    const email = (this.$route.query && this.$route.query.email) ? this.$route.query.email : ''
    this.formValidate.email = email
  },
  watch: {
    language(val) {
      this.reload();
    },
  },
};
</script>

<style lang="less" scoped>
.Gtinput-field {
  position: relative;
  margin-bottom: 18px;
}

.eye-icon {
  position: absolute;
  top: 0px;
  right: 0;
  line-height: 50px;
  height: 45px;
  text-align: center;
  z-index: 2;
  width: 40px;
  font-size: 14px;
  color: #93a2bb;
}

.hide-opcity {
  opacity: 0.3;
}
.keep-box {
  font-size: 14px;
  margin-bottom: 18px;
}
.keep-status {
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
  Gtinput[type^="checkbox"] {
    display: none;
  }
  color: rgba(0, 32, 89, 0.4);
  a {
    color: rgba(0, 32, 89, 0.4);
  }
  a:hover {
    color: rgba(0, 32, 89, 0.8);
    transition: all 0.2s;
  }
  .keep-label {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }

  .keep-label span {
    width: 15px;
    height: 15px;
    display: inline-block;
    margin-right: 6px;
    border: 1px solid #dce1e6;
    vertical-align: middle;
    border-radius: 3px;
    position: relative;
    transition: all 0.3s;
    background-color: #f6f9fc;
    img {
      display: none;
    }
  }
  .keep-label span:hover {
    border: 1px solid rgba(36, 97, 246, 0.4);
  }
  .keep-label span.is-rember {
    background: #2461f6;
    transition: all 0.3s;
    border: 1px solid rgba(36, 97, 246, 1);
    img {
      display: inline-flex;
      width: 11px;
      height: 8px;
      position: absolute;
      top: 3px;
      left: 1px;
    }
  }
}
.page-title {
  font-size: 24px;
  line-height: 35px;
  text-align: center;
  margin-bottom: 36px;
  font-weight: 600;
}
.page-note {
  font-size: 14px;
  line-height: 20px;
  margin-top: 16px;
  text-align: center;
  a {
    color: #3973FF;
    cursor: pointer;
    transition: all .3s;
  &:hover {
    color: #4172fa;
    font-weight: 500;
  }
  }
  
}
.geetest-btn.disabled {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.6;
}

.check_email {
  display: flex;
  margin-bottom: 16px;
}
.geetest-check-risk {
  margin-bottom: 14px;
  margin-right: 10px;
  width: 170px;
  height: 46px;
  display: inline-flex;
}
.captcha-wrapper {
  margin-bottom: 18px;
}
</style>


// WEBPACK FOOTER //
// login.vue?3370f048